import { CustomTemplateRegistry } from "../CustomTemplates.js";
export const isolatedTemplateRegistryMap = new Map();
export function registerIsolatedTemplates(isolatedRoot, templates) {
  let registry = isolatedTemplateRegistryMap.get(isolatedRoot);
  if (!registry) {
    registry = new CustomTemplateRegistry(true);
    isolatedTemplateRegistryMap.set(isolatedRoot, registry);
  }
  registry.clearIsolatedRegistry();
  if (Array.isArray(templates)) {
    for (const tpl of templates) {
      registry.define(tpl.name, tpl);
    }
  }
}
//# sourceMappingURL=IsolatedTemplates.js.map